import { render, staticRenderFns } from "./warning-icon.vue?vue&type=template&id=4c58ecdf&scoped=true"
import script from "./warning-icon.vue?vue&type=script&lang=js"
export * from "./warning-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c58ecdf",
  null
  
)

export default component.exports